//
//
//
//
//
//
//
//
//
//

export default {
  name: 'OutlineButton',
  props: {
    colour: {
      type: String,
      default: 'gradient',
      validator: value => [
        'gradient',
        'default'
      ].includes(value)
    }
  }
}
